import Resource from 'api/resource';

class AssignmentTypeResource extends Resource {
  constructor() {
    super('assignment-types');
  }
}

export { AssignmentTypeResource as default };
